import { render } from "./DashboardData.vue?vue&type=template&id=cd74ecce&scoped=true"
import script from "./DashboardData.vue?vue&type=script&lang=js"
export * from "./DashboardData.vue?vue&type=script&lang=js"

import "./DashboardData.vue?vue&type=style&index=0&id=cd74ecce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd74ecce"

export default script